import { BaseModel } from "model/BaseModel";
import VeiculoItemInspecao from "./VeiculoItemInspecao";
import { BaseEditModel } from "model/BaseEditModel";
import ManutencaoVeiculo from "./ManutencaoVeiculo";

export default class ItemManutencaoVeiculo implements BaseEditModel {

    id: number;
    codigo: string | null;
    sequencial: number | null = null;
    key: string | null = null;
    manutencaoVeiculo: ManutencaoVeiculo|null;
	veiculoItemInspecao: VeiculoItemInspecao|null;
	valor: number;
    descricaoInspecao: string | null;
	descricao: string;

    constructor(
        id = 0,
        codigo = null,
        manutencaoVeiculo = null,
        veiculoItemInspecao = null,
        valor = 0,
        descricaoInspecao: string | null = null,
        descricao = ''
    ) {
        this.id = id;
        this.codigo = codigo;
        this.veiculoItemInspecao = veiculoItemInspecao;
        this.valor = valor;
        this.descricaoInspecao = descricaoInspecao;
        this.descricao = descricao;
        this.manutencaoVeiculo = manutencaoVeiculo;
    }

}